/** Shared app metadata. On-chain identity is configured separately in elysium.ts. */
export const DEX_TOKEN = Object.freeze({
  name: "Merkle",
  symbol: "Merkle",
  decimal: 18,
})
